export enum StringMatchingLevel {
  EXACT = 0,
  IGNORE_PUNCTUATION = 1,
  MATCH_TEXT_90_PERCENT = 2,
  MATCH_WORDS_90_PERCENT = 3,
  MATCH_LLM_VALUES = 4,
}
